/**
 * @param {Object | Array} collection
 * @param {string | (key: string) => boolean} key
 * @returns {any[]}
 */
export default function extractPropertiesDeep(collection, key) {
    if (!collection || typeof collection !== 'object') {
        return [];
    }

    const array = [];

    const isValid = (
        typeof key === 'function' ? key
        : k => k === key
    );

    for (const p in collection) {
        const value = collection[p];

        if (isValid(p)) {
            array.push(collection[p]);
        }

        if (value && typeof value === 'object') {
            array.push(...extractPropertiesDeep(value, key));
        }
    }

    return array;
}